import merge from 'lodash/merge';

import { createTheme } from '@mui/material/styles';

import { palette } from 'src/theme/palette';
import { shadows } from 'src/theme/shadows';
import { typography } from 'src/theme/typography';
import { customShadows } from 'src/theme/custom-shadows';
import { componentsOverrides } from 'src/theme/overrides';

import { BrandPalette } from './derive-brand-palette';

// ----------------------------------------------------------------------

// Distinct display font for portal headlines (loaded via index.html). Body/UI stays on the
// app's primary font; only headings use this, per the design brief.
export const PORTAL_DISPLAY_FONT = "'Fraunces', 'Public Sans', serif";

// The portal is light-only (design brief): build a fresh light theme regardless of the staff
// app's mode, with the agency's brand color injected as `primary`. Client pages render inside
// this so every surface — chrome included — carries the agency identity.
export function createPortalTheme(brand: BrandPalette) {
  const basePalette = palette('light');

  const theme = createTheme({
    palette: {
      ...basePalette,
      mode: 'light',
      primary: {
        lighter: brand.tint,
        light: brand.tintBorder,
        main: brand.interactive,
        dark: brand.dark,
        darker: brand.dark,
        contrastText: brand.onInteractive,
      },
    },
    shadows: shadows('light'),
    customShadows: customShadows('light'),
    shape: { borderRadius: 8 },
    typography,
  });

  theme.components = merge({}, componentsOverrides(theme));
  return theme;
}
